<template>
  <Container
      :options="{ width: 3840, height: 1675 }"
      style="padding-bottom: 30px"
  >
    <jtHeader></jtHeader>
    <div class="content">
      <div class="top-container">
        <div class="item">
          <RailWayData
              :list="railWayData"
              class="animate-left"
              :class="{ 'animate-left-hide': hide }"
          ></RailWayData>
        </div>

        <div class="item">
          <StorageGoods
              class="animate-left"
              :class="{ 'animate-left-hide': hide }"
              v-if="isStorageGoods"
              :tbWarehousingGoods="tbWarehousingGoods"
          ></StorageGoods>
          <!-- <StorageGoods></StorageGoods> -->
        </div>
        <div class="item">
          <ContainerGoods
              class="animate-left"
              :class="{ 'animate-left-hide': hide }"
              v-if="isContainerGoods"
              :tbContainerYards="tbContainerYards"
          ></ContainerGoods>
        </div>
      </div>
      <div class="top-container2">
        <!-- 累计 -->
        <div
            class="item3 count-item count animate-top"
            :class="{ 'animate-top-hide': hide }"
        >
          <Count :monthCarTS="monthCarTS" :monthCarTA="monthCarTA"></Count>
        </div>

        <!-- //箱区管理 -->
        <div
            class="boxArea animate-bottom"
            :class="{ 'animate-bottom-hide': hide }"
        >
          <BoxArea></BoxArea>
        </div>

        <!-- 在途预报 -->
        <div class="inTransit">
          <!-- <SwiperData
            class="swiperData animate-bottom"
            :dataList="tbForecastOnWays"
            title="在途预报"
           
          ></SwiperData> -->
          <SwiperData
              class="swiperData animate-bottom"
              :class="{ 'animate-bottom-hide': hide }"
          ></SwiperData>
        </div>
      </div>

      <div class="top-container3">
        <!-- 车辆进出情况 -->
        <div class="item">
          <!-- <CarCount
          class="animate-right"
         
          v-if="isCarCount"
         :tbVehicleAccessList="tbVehicleAccessList">
        </CarCount> -->
          <CarCount class="animate-right" :class="{ 'animate-right-hide': hide }"></CarCount>
        </div>

        <!-- 集装箱办理量 -->
        <div class="item">
          <!-- <ContainerHandler
          class="animate-right"
          :class="{ 'animate-right-hide': hide }"
          v-if="isContainerHandler"
          :tbContainerHandlingVolumeList="tbContainerHandlingVolumeList"
        ></ContainerHandler> -->
          <ContainerHandler class="animate-right" :class="{ 'animate-right-hide': hide }"></ContainerHandler>
        </div>

        <div class="item">
          <!-- <Notice
          class="animate-right"
          :class="{ 'animate-right-hide': hide }"
          :list="tbGeneralSituation"
        ></Notice> -->
          <Notice class="animate-right" :class="{ 'animate-right-hide': hide }"></Notice>
        </div>
      </div>
    </div>
  </Container>
</template>
<script>
// import { getDatas } from '@/api/api'
import Container from "@/components/Container";
import jtHeader from "@/components/Header";
import RailWayData from "./components/RailwayData";
import StorageGoods from "./components/StorageGoods";
import ContainerGoods from "./components/ContainerGoods";
import ContainerHandler from "./components/ContainerHandler";
import CarCount from "./components/CarCount";
import SwiperData from "./components/SwiperData";
import Count from "./components/Count";
import Notice from "./components/Notice";
import axios from "axios";
import BoxArea from "./components/BoxArea";

export default {
  components: {
    Container,
    jtHeader,
    RailWayData,
    StorageGoods,
    ContainerGoods,
    SwiperData,
    Count,
    Notice,
    CarCount,
    ContainerHandler,
    BoxArea,
  },
  data() {
    return {
      hide: false,
      hidebottom: true,
      isStorageGoods: true,
      isContainerGoods: true,
      isCarCount: false,
      isContainerHandler: false,
      fullscreen: false,
      monthCarTS: 0,
      monthCarTA: 0,
      railWayData: [], //铁路
      tbWarehousingGoods: {
        documentDate: [],
        warehousingInToday: [],
        warehousingOutToday: [],
        warehousingBalanceToday: [],
      }, //仓储货物到达情况
      tbContainerYards: {
        documentDate: [],
        containerInoutTodayWeight: [], //今日进
        containerInoutTodayAir: [], //今日出
        containerBalanceTodayAir: [], //今天结存
      },
      //集装箱堆场到发情况
      tbVehicleAccessList: {
        documentDate: [],
        inToday: [], //今日进
        outToday: [], //今日出
      },
      //车辆进出情况
      tbContainerHandlingVolumeList: {
        //isContainerHandler
        documentDate: [],
        arrived: [], //日到达
        send: [], //日发送
      },
      tbForecastOnWays: [],
      tbCarDistributions: [],
      tbGeneralSituation: [],
    };
  },
  methods: {
    handleFullscreen() {
      this.fullscreen = !this.fullscreen;
    },
    handleChange() {
      this.handleFullscreen();
    },

    handlerRailWayData(data) {
      let _this = this;

      function _handler(_data, title, index, color) {
        _this.railWayData.push({
          imgUrl: require(`@/assets/images/icon_${index}.png`),
          title: title,
          num: _data ? parseInt(_data) : 0,
          color: color,
        });
      }

      for (let val in data) {
        if (val == "sentCarYesterday") {
          _handler(data[val], "日发送车", 1, "#2df9cc");
        }
        if (val == "unloadCarYesterday") {
          _handler(data[val], "日到达车", 2, "#EFFF72");
        }
        if (val == "monthCarS") {
          _handler(data[val], "累计发送车", 3, "#FA9931");
        }
        if (val == "monthCarA") {
          _handler(data[val], "累计到达车", 4, "#FA9931");
        }
        if (val == "sentTYesterday") {
          _handler(data[val], "日发送吨", 5, "#34DAFA");
        }
        if (val == "unloadTonnesYesterday") {
          _handler(data[val], "日到达吨", 6, "#29F8E9");
        }
      }
    },
    // getData1(){
    //   getDatas().then(res => {
    //     console.log(res,'resres')
    //   })
    // },
    getData() {
      axios({
        method: "get",
        url: "http://172.20.123.208:9000/api/screen/statistics/bigScreenData",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json;charset=utf-8",
        },
        //url: "http://diaodu.lywly.com.cn/prod-api/home/screen",
        // url: "http://150.139.212.142:19091/home/screen",
      }).then((res) => {
        this.handlerRailWayData(res.data.data);
        this.monthCarTS = parseInt(res.data.data.monthCarTS);

        this.monthCarTA = parseInt(res.data.data.monthCarTA);
        if (res.data.data.tbVehicleAccessList.length > 0) {
          res.data.data.tbVehicleAccessList.forEach((element) => {
            this.tbVehicleAccessList.documentDate.push(element.documentDate);
            this.tbVehicleAccessList.inToday.push(element.in_today);
            this.tbVehicleAccessList.outToday.push(element.out_today);
          });
        } else {
          this.tbVehicleAccessList = {};
        }

        res.data.data.tbWarehousingGoods.forEach((element) => {
          this.tbWarehousingGoods.documentDate.push(element.documentDate);
          this.tbWarehousingGoods.warehousingInToday.push(
              element.warehousingInToday
          );
          this.tbWarehousingGoods.warehousingOutToday.push(
              element.warehousingOutToday
          );
          this.tbWarehousingGoods.warehousingBalanceToday.push(
              element.warehousingBalanceToday
          );
        });

        if (res.data.data.tbContainerHandlingVolumeList.length > 0) {
          res.data.data.tbContainerHandlingVolumeList.forEach((element) => {
            this.tbContainerHandlingVolumeList.documentDate.push(
                element.documentDate
            );
            this.tbContainerHandlingVolumeList.arrived.push(element.arrived);
            this.tbContainerHandlingVolumeList.send.push(element.send);
          });
        } else {
          this.tbContainerHandlingVolumeList = {};
        }
        res.data.data.tbContainerYards.forEach((element) => {
          this.tbContainerYards.documentDate.push(element.documentDate);
          this.tbContainerYards.containerInoutTodayWeight.push(
              element.containerInoutTodayWeight
          );
          this.tbContainerYards.containerInoutTodayAir.push(
              element.containerInoutTodayAir
          );
          this.tbContainerYards.containerBalanceTodayAir.push(
              element.containerBalanceTodayAir != null
                  ? element.containerBalanceTodayAir
                  : 0
          );
        });

        let {values} = Object;
        res.data.data.tbForecastOnWays.forEach((v) => {
          this.tbForecastOnWays.push(values(v).reverse());
        });

        res.data.data.tbCarDistributions.forEach((v) => {
          this.tbCarDistributions.push(values(v).reverse());
        });

        this.tbGeneralSituation = res.data.data.tbGeneralSituation;
        this.isStorageGoods = true;
        this.isContainerGoods = true;
        this.isCarCount = true;
        this.isContainerHandler = true;
      });
    },
  },
  mounted() {
    this.handleChange();
  },
  created() {
    setTimeout(() => {
      this.hide = true;
    }, 500);
    setInterval(() => {
      this.hidebottom = !this.hidebottom;
    }, 10000);
    this.getData();
  },
};
</script>
<style scoped>
.container {
  /* position: relative; */
}

.content {
  width: 3576px;
  height: 1355px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 65px auto;
}

.top-container {
  width: 950px;
  height: 1355px;
  display: flex;
  flex-direction: column;
  align-content: space-between;
}

.top-container2 {
  width: 1565px;
  height: 1355px;
  display: flex;
  flex-direction: column;
  align-content: space-around;
}

.top-container3 {
  width: 967px;
  height: 1355px;
  display: flex;
  flex-direction: column;
  align-content: space-around;
}

.item {
  width: 950px;
  height: 429px;
  margin-bottom: 12px;
}

.item2 {
  width: 100%;
  height: 30%;
}

.item3 {
  width: 100%;
  height: 128px;
  margin-top: 45px;
}

.item2:nth-child(1) {
  margin-top: 7px;
  margin-bottom: 27 rpx;
}

.boxArea {
  width: 100%;
  height: 661px;
  margin-top: 34px;
}

.bg {
  width: 3939px;
  height: 1675px;
  background-size: cover;
}

.left-content {
  position: absolute;
  width: 24%;
  height: calc(100% - 22px);
  top: 10%;
  left: 7%;
}

.right-content {
  width: 24%;
  position: absolute;
  top: 10%;
  right: 7%;
}

.swiperData {
  width: 100%;
  height: 103%;
}

.inTransit {
  width: 100%;
  height: 420px;
  margin-top: 11px;
}

.animate-left {
  transform: translateX(-1300px);
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-left-hide {
  transform: translateX(0px);
}

.animate-right {
  transform: translateX(1300px);
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-right-hide {
  transform: translateX(0px);
}

.animate-top {
  transform: translateY(-1300px);
  opacity: 0;
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-top-hide {
  transform: translateY(0px);
  opacity: 1;
}

.animate-bottom {
  transform: translateY(1000px);
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-bottom-hide {
  transform: translateY(0px) !important;
}
</style>
